import * as assets from "./madnesAssetsAdapter";
import { getAudioTracks } from "../../framework/src/engine/madnes/MadnesAudio"
import * as madnes from "../../framework/src/engine/madnes/madnes";

import {
    set_config_load_symbols,
    to_load_audio_madnes
} from "../../framework/src/engine/madnes/madnes_variables";
import {madnes_set_win_factors} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_sprite} from "../../framework/src/engine/madnes/madnes";
import {madnes_set_audio_volume, madnes_set_default_volume} from "../../framework/src/engine/madnes/madnes_audio";

import {GAME_EVENTS} from "../../framework/src/game/gameEvents";
import {WALLET_EVENTS} from "../../framework/src/wallet/Wallet";
import {
    gameInfo,
    infomenuClose, infomenuHome,
    infomenuInit,
    infomenuLeft,
    infomenuOpen, infomenuRight,
    infomenuUpdate, jbp_init_desk,
    rotateRun,
    game
} from "../init";
import { main_phaser } from "../../framework/src/engine/madnes/MadnesApp";


export const infotexts_languages = [
    "bg", "cs", "de", "en", "es", "es-mx", "fr", "hr", "it", "nl", "pl", "pt", "ro", "sk",
];

export function initGame(gameset) {

    gameset.game.audio.tracks = getAudioTracks(assets.to_load_audio);
    gameset.system.audio.tracks = getAudioTracks(to_load_audio_madnes);

    madnes.set_ico_size(200, 184);

    madnes_set_win_factors(25, 50, 125);

    madnes_set_sprite("coins", 152, 152);

    set_config_load_symbols(false);

    madnes_set_sprite('_sprite', 320, 280);
    madnes_set_sprite('_blur', 320, 280);

    madnes_set_sprite('bigwin_sprite', 758, 510);

    madnes_set_default_volume(0.8);
    madnes_set_audio_volume("reel", 0.6);

    madnes_set_default_volume(0.8);

}

export function notify(eventName, data, prevData) {

    switch(eventName) {

        case GAME_EVENTS.GAME_FREESPIN_END:
        case GAME_EVENTS.GAME_END_ROUND_FREESPINS:
            freespins_end_round(eventName, data);
            break;

        case GAME_EVENTS.GAME_END_ROUND_RECALCED:
            end_round_recalced(eventName, data);
            break;

        case WALLET_EVENTS.WALLET_ON_SET_BET:
            game.memory.reinit()
            infomenu_update();
            break;

        // case ACTION_EVENTS.ACTION_BETMENU_OPEN:
        //     soe_lines_open();
        //     break;

        // //case ACTION_EVENTS.ACTION_BETMENU_CLOSE:
        //     soe_lines_close(data);
        //     break;

        // case UISLIDER_EVENTS.UISLIDER_CHANGE_LINES:
        //     // soe_lines_change();
        //     break;
    }
}

export function on_set_bet() {
    infomenu_update();
}

export function game_start() {
    main_phaser.tweens.frameBased = true
    rotateRun()
}

export function print_desk() {
    jbp_init_desk()
}

export function print_reels() {
}

export function infomenu_init() {
    infomenuInit();
}

export function infomenu_open() {
    infomenuOpen();
}

export function infomenu_close() {
    infomenuClose();
}

export function is_info_open() {
    return gameInfo.opened;
}

export function infomenu_left() {
    infomenuLeft();
}

export function infomenu_right() {
    infomenuRight();
}

export function infomenu_update() {
    infomenuUpdate();
}

export function infomenu_home() {
    infomenuHome();
}

export function end_round_recalced(eventName, {autostart}) {
    // mv81_end_round_recalced();

    if(!autostart) {
        end_round_no_autostart();
    }
}

export function end_round_no_autostart() {}

export function freespins_end_round(eventName, {ended}) {}

export function get_preinfo() {
    return;
}

export function preinfo_close() {
}